import { render } from "./ReportNotFound.vue?vue&type=template&id=7615500f"
import script from "./ReportNotFound.vue?vue&type=script&lang=js"
export * from "./ReportNotFound.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\feature_RPTWEB-3605_SERIALIZE-JAVASCRIPT_upgrade\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__